/**
 * Koz Review Slider — scroll exactly one card per prev/next click.
 */
(function () {
  function getScrollTarget(container, card) {
    return card.offsetLeft - container.clientLeft;
  }

  function getCurrentIndex(container, cards) {
    var scrollLeft = container.scrollLeft;
    var index = 0;
    var minDiff = Infinity;

    for (var i = 0; i < cards.length; i++) {
      var diff = Math.abs(getScrollTarget(container, cards[i]) - scrollLeft);
      if (diff < minDiff) {
        minDiff = diff;
        index = i;
      }
    }

    return index;
  }

  function scrollToIndex(container, cards, index) {
    index = Math.max(0, Math.min(cards.length - 1, index));
    container.scrollTo({
      left: getScrollTarget(container, cards[index]),
      behavior: 'smooth',
    });
  }

  function initSection(section) {
    var container = section.querySelector('[data-koz-rev-track]');
    var prevBtn = section.querySelector('[data-koz-rev-prev]');
    var nextBtn = section.querySelector('[data-koz-rev-next]');

    if (!container) return;

    var cards = container.querySelectorAll('.rev-card');
    if (!cards.length) return;

    function go(delta) {
      var current = getCurrentIndex(container, cards);
      scrollToIndex(container, cards, current + delta);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        go(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        go(1);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-koz-rev-slider]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-koz-rev-slider]');
    if (section) initSection(section);
  });
})();
